import { Modal } from '@lunary/ui-web/modal'
import { useState } from 'react'
import type { ReactNode } from 'react'
import styles from './confirm-dialog.module.css'

type Props = {
  readonly open: boolean
  readonly title: string
  readonly text: string
  readonly confirmLabel: string
  readonly danger?: boolean
  readonly reasonLabel?: string
  readonly details?: ReactNode
  readonly pending?: boolean
  readonly error?: string | null
  readonly onConfirm: (reason: string) => void
  readonly onClose: () => void
}

export function ConfirmDialog({ open, title, text, confirmLabel, danger, reasonLabel, details, pending, error, onConfirm, onClose }: Props) {
  const [reason, setReason] = useState('')
  const [wasOpen, setWasOpen] = useState(open)
  if (open !== wasOpen) {
    setWasOpen(open)
    if (open) setReason('')
  }
  const hasBody = Boolean(details) || Boolean(reasonLabel) || Boolean(error)

  return (
    <Modal
      open={open}
      size="sm"
      role={danger ? 'alertdialog' : 'dialog'}
      title={title}
      description={text}
      dismissible={!pending}
      onClose={onClose}
      onSubmit={(e) => {
        e.preventDefault()
        if (!pending) onConfirm(reason.trim())
      }}
      footer={
        <>
          <button type="button" className="secondary" disabled={pending} onClick={onClose}>
            Отмена
          </button>
          <button type="submit" className={danger ? 'danger' : undefined} disabled={pending}>
            {pending ? 'Минуту…' : confirmLabel}
          </button>
        </>
      }
    >
      {hasBody && (
        <>
          {details}
          {reasonLabel && (
            <label className={styles.field}>
              <span className="muted">{reasonLabel}</span>
              <textarea rows={3} maxLength={500} value={reason} onChange={(e) => setReason(e.target.value)} />
            </label>
          )}
          {error && (
            <p className="error-box" role="alert">
              {error}
            </p>
          )}
        </>
      )}
    </Modal>
  )
}
